import React from "react";
import {
    CONTEST_STATUS, CONTEST_STATUS_BG_TABLE, CONTEST_STATUS_TEXT
} from "../UIHelpers";

export const StatusFormatter = ((row) => 
    {
     return(   
    <span
        className={`label label-lg text-uppercase ${CONTEST_STATUS_TEXT[row]} ${CONTEST_STATUS_BG_TABLE[row]
            } label-inline`}
    >
        {CONTEST_STATUS[row]}
    </span>)
    // console.log("row",row)
    // <></>
        }
);
